import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  divider: {
    marginTop: theme.spacing(3),
  },
  paper: {
    marginTop: 100,
    paddingTop: 40,
    paddingBottom: 15,
    paddingLeft: 36,
    paddingRight: 36,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    margin: theme.spacing(1),
    height: 47,
  },
  form: {
    color: '#1e1e1e',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  formControl: {
    margin: 0,
  },
  inputLabel: {
    marginLeft: 10,
    marginTop: 16,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  submitPasswordChange: {
    margin: theme.spacing(1, 0, 2),
  },
  sso: {
    margin: theme.spacing(1, 0, 3),
  },
  link: {
    fontSize: 12,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  passwordRequirements: {
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  errorArray: {
    paddingLeft: theme.spacing(2),
    marginBottom: 0,
  },
  version: {
    marginRight: theme.spacing(-2.5),
  },
  privacyStatement: {
    marginLeft: theme.spacing(-2.5),
    cursor: "pointer",
    '&:hover': {
      textDecoration: 'underline',
    },
  }
}));